export class InventoryHeirarchyUpperLevelView {
    public productId: string;
    public productName: string;
    public productAttributeTypeCode: string;
    public productAttributeTypeName: string;
    public productAttributeChoiceId: string;
    public productAttributeChoiceName: string;
    public hierarchyKey: string;
    public hierarchyLength: Number;
}